<template>
	<transition
			appear
			:appear-active-class="$_inpSlt_styleInputSelectAnimation()">
		<v-row no-gutters>
			<v-col>
				<validation-provider
						:name="'InputSelect-' + contentKey"
						:rules="getValidationRules(contents[contentKey].rules)"
						v-slot="{ errors }">
					<v-autocomplete
							v-model="$store.state.input.data[contentKey].answer"
					
							return-object

							:background-color="$_inpSlt_styleSelectBackgroundColor"
							:chips="$_inpSlt_styleSelectChips"
							:clearable="$_inpSlt_styleSelectClearable"
							:color="$_inpSlt_styleSelectColor"
							:deletable-chips="$_inpSlt_styleSelectDeletableChips"
							:dark="$_inpSlt_styleSelectDark"
							:dense="$_inpSlt_styleSelectDense"
							:filled="$_inpSlt_styleSelectFilled"
							:flat="$_inpSlt_styleSelectFlat"
							:light="$_inpSlt_styleSelectLight"
							:outlined="$_inpSlt_styleSelectOutlined"
							:small-chips="$_inpSlt_styleSelectSmallChips"
							:solo="$_inpSlt_styleSelectSolo"
							:solo-inverted="$_inpSlt_styleSelectSoloInverted"

							:append-icon="$_inpSlt_styleParamAppendIcon(contents[contentKey].params)"
							:append-outer-icon="$_inpSlt_styleParamAppendOuterIcon(contents[contentKey].params)"
							:prepend-icon="$_inpSlt_styleParamPrependIcon(contents[contentKey].params)"
							:prepend-inner-icon="$_inpSlt_styleParamPrependInnerIcon(contents[contentKey].params)"

							:hint="$_inpSlt_langParamHint(contents[contentKey].params)"
							:message="$_inpSlt_langParamMessage(contents[contentKey].params)"
							:placeholder="$_inpSlt_langParamPlaceholder(contents[contentKey].params)"
							:prefix="$_inpSlt_langParamPrefix(contents[contentKey].params)"
							:suffix="$_inpSlt_langParamSuffix(contents[contentKey].params)"

							item-avater="icon"
							item-text="text"
							item-value="key"
							:items="arrayObject(contents[contentKey].options)"

							:error-messages="errors" />
				</validation-provider>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'InputSelect',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			// lang
			$_inpSlt_langParamHint() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.hint;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpSlt_langParamMessage() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.message;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpSlt_langParamPlaceholder() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.placeholder;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpSlt_langParamPrefix() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prefix;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpSlt_langParamSuffix() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.suffix;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			// style
			$_inpSlt_styleInputSelect() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'inputSelect')
				}
			},
			$_inpSlt_styleInputSelectAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_inpSlt_styleInputSelect()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_inpSlt_styleSelect() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'select')
			},
			$_inpSlt_styleSelectBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_inpSlt_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_inpSlt_styleSelectChips() {
				const self_ = this;
				const style_ = self_.$_inpSlt_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.chips)
			},
			$_inpSlt_styleSelectClearable() {
				const self_ = this;
				const style_ = self_.$_inpSlt_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.clearable)
			},
			$_inpSlt_styleSelectColor() {
				const self_ = this;
				const style_ = self_.$_inpSlt_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_inpSlt_styleSelectDeletableChips() {
				const self_ = this;
				const style_ = self_.$_inpSlt_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.deletableChips)
			},
			$_inpSlt_styleSelectDark() {
				const self_ = this;
				const style_ = self_.$_inpSlt_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_inpSlt_styleSelectDense() {
				const self_ = this;
				const style_ = self_.$_inpSlt_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dense)
			},
			$_inpSlt_styleSelectFilled() {
				const self_ = this;
				const style_ = self_.$_inpSlt_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.filled)
			},
			$_inpSlt_styleSelectFlat() {
				const self_ = this;
				const style_ = self_.$_inpSlt_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.flat)
			},
			$_inpSlt_styleSelectLight() {
				const self_ = this;
				const style_ = self_.$_inpSlt_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_inpSlt_styleSelectOutlined() {
				const self_ = this;
				const style_ = self_.$_inpSlt_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.outlined)
			},
			$_inpSlt_styleSelectSmallChips() {
				const self_ = this;
				const style_ = self_.$_inpSlt_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.smallChips)
			},
			$_inpSlt_styleSelectSolo() {
				const self_ = this;
				const style_ = self_.$_inpSlt_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.solo)
			},
			$_inpSlt_styleSelectSoloInverted() {
				const self_ = this;
				const style_ = self_.$_inpSlt_styleSelect;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.soloInverted)
			},
			$_inpSlt_styleParamAppendIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.appendIcont;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpSlt_styleParamAppendOuterIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.appendOuterIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpSlt_styleParamPrependIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prependIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpSlt_styleParamPrependInnerIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prependInnerIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			}
		}
	}
</script>

<style scoped>
</style>
